"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var CmsPageRecordCk4Editor = /** @class */ (function (_super) {
    __extends(CmsPageRecordCk4Editor, _super);
    function CmsPageRecordCk4Editor(props) {
        return _super.call(this, props) || this;
    }
    CmsPageRecordCk4Editor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            textRaw: UIUtils_1.UIUtils.Base64DecodeU(this.props.textBase64),
            is_fullscreen: false
        }, function () {
            window['SK_EDIT_SEL_IMG_DIALOG_SHOW'] = function (cb) {
                _this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
                    if (cb) {
                        cb(brandIdentity + "/" + dirName + "/" + fileName);
                    }
                    _this.props.dialogSelectImage.Close();
                }).Show();
            };
        });
        this.props.state.setExtBreadCrumbPath([
            "Список страниц",
            "Список записей",
            "\u0412\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430: [" + this.props.record.title + "]"
        ]);
    };
    CmsPageRecordCk4Editor.prototype.componentDidMount = function () {
        var _this = this;
        CKEDITOR.replace('editor1', {
            allowedContent: true,
            height: 300,
            width: "100%",
            baseHref: this.props.data.DATA.cdn_baseurl //'http://hostpc.com/cdn/'
        });
        CKEDITOR.instances['editor1'].on('change', function () {
            _this.setState({ textRaw: CKEDITOR.instances['editor1'].getData() });
        });
        CKEDITOR.instances['editor1'].on('instanceReady', function () {
            CKEDITOR.instances['editor1'].setData(_this.state.textRaw);
        });
        //  CKEDITOR.instances['editor1'].config.height = this.getEditorHeight();  
    };
    CmsPageRecordCk4Editor.prototype.getEditorHeight = function () {
        if (this.state.is_fullscreen) {
            return "calc( 100vh - 420px )";
        }
        else {
            return "300px";
        }
    };
    CmsPageRecordCk4Editor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.SetDataContent(this.props.record.key, UIUtils_1.UIUtils.Base64EncodeU(this.state.textRaw), function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись изменена!");
            });
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Контент не может быть пуcтым!");
        }
    };
    CmsPageRecordCk4Editor.prototype.isDataValid = function () {
        if (!this.state.textRaw) {
            return false;
        }
        if (this.state.textRaw.length === 0) {
            return false;
        }
        return true;
    };
    CmsPageRecordCk4Editor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsPageRecordCk4Editor.prototype.OnMaxButtonClick = function (isMax) {
        var _this = this;
        this.setState({ is_fullscreen: isMax }, function () {
            var editor = CKEDITOR.instances['editor1'];
            editor.config.resize_dir = 'both';
            editor.config.height = _this.getEditorHeight();
            editor.config.width = '100%';
            editor.resize(editor.config.width, editor.config.height);
        });
    };
    CmsPageRecordCk4Editor.prototype.getFormTitle = function () {
        return "Изменить контент";
    };
    CmsPageRecordCk4Editor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 640, showMaxButton: true },
            React.createElement("div", { style: {
                    minHeight: "550px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement("textarea", { name: "editor1", id: "editor1", rows: 1, cols: 1 }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }))));
    };
    return CmsPageRecordCk4Editor;
}(React.Component));
exports.default = CmsPageRecordCk4Editor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_pages/ui/component/CmsPageRecordCk4Editor.tsx
// module id = 2403
// module chunks = 0